var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LoginDeviceRequest, LoginDeviceUpdateState } from "@/share/LoginDevice";
import { action, makeObservable, observable } from "mobx";
import { ProgressBarState } from "../UIComponents/ProgressBar";
export class LoginViewStore {
    constructor() {
        this.password = "";
        this.showpassword = false;
        this.tryinglogin = false;
        this.error = "";
        this.progressstate = new ProgressBarState();
        makeObservable(this);
        this.progressstate.setColor("green");
        APPEvent.addSubscriberForReset(() => this.reset());
        APPEvent.addSubscriberForLoginDevice((update) => {
            if (update.errormessage) {
                this.setTryingLogin(false);
                APPEvent.publishApperror(update.errormessage);
                this.setPassword("");
            }
            else {
                if (update.state === LoginDeviceUpdateState.ValidatingPin) {
                    this.setProgress(30);
                    this.setProgressMessage("Validaing User");
                }
                else if (update.state === LoginDeviceUpdateState.Bootstrapping) {
                    this.setProgress(60);
                    this.setProgressMessage("Setting up the device");
                }
                else if (update.state === LoginDeviceUpdateState.Success) {
                    this.setProgress(90);
                    this.setProgressMessage("Doing final checks");
                }
                else if (update.state === LoginDeviceUpdateState.ValidatingDevice) {
                    this.setProgress(45);
                    this.setProgressMessage("Validating Device");
                }
            }
        });
    }
    setTryingLogin(trying) {
        this.tryinglogin = trying;
    }
    toggleShowPassword() {
        this.setShowPassword(!this.showpassword);
    }
    setShowPassword(show) {
        this.showpassword = show;
    }
    setPassword(password) {
        this.password = password;
    }
    setProgress(pr) {
        this.progressstate.setProgress(pr);
    }
    setProgressMessage(msg) {
        this.progressstate.setProgressMessage(msg);
    }
    loginDevice() {
        if (!this.password) {
            return;
        }
        this.loginDeviceExternal(this.password);
    }
    loginDeviceExternal(password, masterpassword) {
        this.setProgress(0);
        this.setProgressMessage("");
        this.setTryingLogin(true);
        const req = new LoginDeviceRequest(password, masterpassword);
        Apphandler.sendMessage("logindevice", req);
    }
    reset() {
        this.setPassword("");
        this.setTryingLogin(false);
        this.setShowPassword(false);
        this.setProgress(0);
        this.setProgressMessage("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewStore.prototype, "password", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewStore.prototype, "showpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewStore.prototype, "tryinglogin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LoginViewStore.prototype, "error", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LoginViewStore.prototype, "setTryingLogin", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LoginViewStore.prototype, "setShowPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LoginViewStore.prototype, "setPassword", null);
